module.exports = __webpack_public_path__ + "img/test31_big.2a73c047.jpg";